export function setAuthUser(state, payload) {
    state.authUser = payload;
}

export function resetAuthUser(state, payload) {
    state.authUser = {}
    state.firebaseToken = null
    state.firebaseAuthUser = {}
    state.firebaseUserData = {}
}

export function setFirebaseToken(state, payload) {
    state.firebaseToken = payload;
}

export function setFirebaseAuthUser(state, payload) {
    state.firebaseAuthUser = payload;
}

export function setFirebaseAuthUserData(state, payload) {
    state.firebaseUserData = payload;
}
export function resetStore(state) {
    state.authUser = {}
    state.firebaseToken = null
    state.firebaseAuthUser = {}
    state.firebaseUserData = {}
}